import React from "react";
import Sugar from "sugar";

Sugar.extend();

function SearchResultPlaceholder() {
  return (
    <section className="search-result placeholder">
      <div className="text">
        <div className="cell">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>

      <div className="data">
        <div className="cell">
          <div className="debt">
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </div>

        <div className="cell">
          <div className="income">
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SearchResultPlaceholder;
